export default {
  solutions: {
    breadcrumbHome: 'Inicio',
    breadcrumbCurrent: 'Soluciones',
    hero: {
      eyebrow: 'Soluciones',
      title: 'La solución adecuada para cada inmueble',
      lead: 'Vivienda, local comercial o almacén: encontramos juntos el sistema de cámaras óptimo para sus necesidades.',
    },
    grid: {
      eyebrow: 'Soluciones por tipo de inmueble',
      title: 'Seis áreas, una promesa: seguridad real',
      lead: 'Cada tarjeta lleva a una vista propia con puntos de vigilancia típicos y soluciones técnicas adecuadas.',
    },
    tag: { privat: 'Privado', gewerbe: 'Empresa', innen: 'Interior', außen: 'Exterior', neu: 'Nuevo', erweiterung: 'Ampliación' },
    more: 'Saber más',
    cta: {
      title: '¿No está seguro de qué solución encaja?',
      lead: 'Analizamos su inmueble juntos y le recomendamos la combinación adecuada de cámaras, grabación y accesorios.',
      primary: 'Asesoría sin compromiso',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
};